import { useTheme } from 'styled-components'

import { FlexColumn } from '@/@bothrs-ui/web/components/layout'
import { AgendaDetail, type AgendaDetailTone } from './AgendaDetail'

import type { ReactNode } from 'react'

type AgendaMomentProps = {
  /** The day, e.g. "Di 20/10/2026". Without it the row is left out. */
  date?: string
  /** The hour, or what stands in for it. Without it the row is left out. */
  time?: string
  timeTone?: AgendaDetailTone
  /** How late the hospital runs, shown after the hour. */
  waitTime?: string
  /** Rows of the item's own that follow the day and the hour, such as the room. */
  children?: ReactNode
}

/** When an agenda item takes place: the day, the hour and any row an item adds after them. */
const AgendaMoment = ({ date, time, timeTone, waitTime, children }: AgendaMomentProps) => {
  const theme = useTheme()

  return (
    <FlexColumn gap={theme.UI.Spacing.Space2}>
      {date ? (
        <AgendaDetail.Row>
          <AgendaDetail.Icon icon={['fal', 'calendar']} />
          <AgendaDetail.Fact>{date}</AgendaDetail.Fact>
        </AgendaDetail.Row>
      ) : null}
      {time ? (
        <AgendaDetail.Row tone={timeTone}>
          <AgendaDetail.Icon icon={['fal', 'clock']} />
          <AgendaDetail.Fact>{time}</AgendaDetail.Fact>
          {waitTime ? <AgendaDetail.WaitTime>{waitTime}</AgendaDetail.WaitTime> : null}
        </AgendaDetail.Row>
      ) : null}
      {children}
    </FlexColumn>
  )
}

export { AgendaMoment }
